import { FormEvent, useState } from 'react';
import { InputBackOffice } from '../../components/common/InputBackoffice';

import { Label, PhoneComp } from '../../styles/stylesStyled';
import { StrengthBar, StrengthText } from './PasswordStyled';

import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Button } from '../../components';
import Spinner from '../../components/common/Spinner';
import { ErrorToast } from '../../components/common/Toasts/Toasts';
import { AuthLayoutTitle, Flexed } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import { signUpPassword } from './Password.actions';

const Password = ({ history }: RouteComponentProps) => {
  const { t } = useTranslation('onboarding');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');

  const [letterUpperCase, setLetterUpperCase] = useState(false);
  const [letterDigit, setLetterDigit] = useState(false);
  const [letterChar, setLetterChar] = useState(false);
  const [passLength, setPassLength] = useState(false);

  const validation = [
    {
      text: t('password.uppercase'),
      strength: 1,
      requirement: letterUpperCase
    },
    {
      text: t('password.special_letter'),
      strength: 2,
      requirement: letterChar
    },
    { text: t('password.number'), strength: 3, requirement: letterDigit },
    { text: t('password.8+character'), strength: 4, requirement: passLength }
  ];

  const upperCase = /^(?=.*?[A-Z])/;
  const digit = /^(?=.*?[0-9])/;
  const specChar = /(?=.*?[#?!@$%^&*-])/;

  const dispatch = useAppDispatch();

  const { loading, register } = useAppSelector((state) => state.auth);

  const { user } = register;

  const confirmPassword = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    //   !letterUpperCase ||
    //   !letterDigit ||
    //   !letterChar ||
    //   !passLength ||
    //   password === ''
    if (password !== password2) {
      ErrorToast(t('password.passwords_do_not_match'));
    } else if (!password && !password2) {
      ErrorToast(t('password.passwords_field_is_empty'));
    } else {
      dispatch(signUpPassword({ id: user?.id, password, history }));
    }
  };

  const checkPassword = (e: string) => {
    setPassword(e);

    if (e.match(upperCase)) {
      setLetterUpperCase(true);
    } else {
      setLetterUpperCase(false);
    }

    if (e.match(digit)) {
      setLetterDigit(true);
    } else {
      setLetterDigit(false);
    }

    if (e.match(specChar)) {
      setLetterChar(true);
    } else {
      setLetterChar(false);
    }

    if (e.length >= 8) {
      setPassLength(true);
    } else {
      setPassLength(false);
    }
  };

  return (
    <>
      {loading && <Spinner fullScreen={true} transparent />}
      <AuthLayoutTitle>{t('password.create_your_password')}</AuthLayoutTitle>

      <form onSubmit={confirmPassword}>
        <Label>Password</Label>
        <InputBackOffice
          id={'password'}
          type={'password'}
          placeholder={t('password.passPlaceholder')}
          name={'password'}
          value={password}
          onChange={(e: string) => checkPassword(e)}
        />

        <Label>Confirm</Label>

        <InputBackOffice
          id={'password2'}
          type={'password'}
          placeholder={t('password.confirmPassPlaceholder')}
          name={'password2'}
          value={password2}
          onChange={setPassword2}
        />

        <Flexed between>
          {validation.map((item, index) => {
            return (
              <StrengthBar
                key={index}
                color={
                  password.length > 0
                    ? item.requirement
                      ? colors.success500
                      : colors.error500
                    : colors.neutral400
                }>
                <StrengthText
                  color={
                    password.length > 0
                      ? item.requirement
                        ? colors.success500
                        : colors.error500
                      : colors.neutral400
                  }>
                  {item.text}
                </StrengthText>
              </StrengthBar>
            );
          })}
        </Flexed>

        <Button
          negative
          m='50px 0 10px 0'
          type='submit'
          disabled={
            !letterUpperCase ||
            !letterDigit ||
            !letterChar ||
            !passLength ||
            password === '' ||
            password2 === ''
          }>
          {t('password.continue')}
        </Button>
      </form>
    </>
  );
};

export default Password;
